<div class="mb-25">
  <!-- Breadcrumb removed but spacing maintained -->
</div>

<div class="applications-container">
  @for (application of filteredApplications; track application) {
    <div class="col-lg-4 col-md-6 application-card">
      <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-header>
          <mat-card-title>
            <h5 class="mb-0">{{ application.organizationName }}</h5>
          </mat-card-title>
          <mat-card-subtitle>
            <p></p>
          </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <p>
            <strong>Natječaj:</strong> {{ application.grantName }}
          </p>
          <p>
            <strong>Naziv programa/projekta:</strong> {{ application.programProjectName }}
          </p>
          <p>
            <strong>Datum predaje:</strong> {{ application.submittedAt | date: 'd.M.yyyy. HH:mm:ss' }}
          </p>
          <p>
            <strong>Status:</strong>
            <span
              class="daxa-badge"
                    [ngClass]="{
                      'evaluation': application.status === ApplicationStatus.PositiveReview || application.status === ApplicationStatus.NegativeReview,
                      'submited': application.status === ApplicationStatus.Submitted,
                      'returned': application.status === ApplicationStatus.Returned,
                      'resubmitted': application.status === ApplicationStatus.Resubmitted,
                      'draft': application.status === ApplicationStatus.Draft,
                      'approved': application.status === ApplicationStatus.Approved,
                      'rejected': application.status === ApplicationStatus.Rejected
                    }"
              >
              {{ application.userFriendlyStatus }}
            </span>
          </p>
        </mat-card-content>
        <mat-card-actions>
          <button mat-icon-button color="primary" matTooltip="Pregledaj prijavu" (click)="goToViewApplication(application)">
            <mat-icon>visibility</mat-icon>
          </button>
          @if (application.isActionAllowed('Edit')) {
            <button mat-icon-button color="primary" matTooltip="Uredi prijavu" (click)="goToEditApplication(application)">
              <mat-icon>edit</mat-icon>
            </button>
          }
          @if (application.isActionAllowed('Delete')) {
            <button mat-icon-button color="warn" matTooltip="Obriši prijavu" (click)="confirmDelete(application)">
              <mat-icon>delete</mat-icon>
            </button>
          }
          @if (application.isActionAllowed('Submit')) {
            <button mat-icon-button color="primary" matTooltip="Predaj prijavu" (click)="confirmSubmit(application)">
              <mat-icon>check_circle</mat-icon>
            </button>
          }
          @if (application.isActionAllowed('Resubmit')) {
            <button mat-icon-button color="primary" matTooltip="Ponovno predaj prijavu" (click)="confirmResubmit(application)">
              <mat-icon>check_circle</mat-icon>
            </button>
          }
          <button mat-icon-button color="primary" matTooltip="Preuzmi obrasce" (click)="downloadForms(application, [ApplicationFormType.B1, ApplicationFormType.B2])">
            <mat-icon>download</mat-icon>
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
  }
</div>
